import type { BatchWaiterLabel } from "./useBatchWaiterLabels";

/**
 * Надписът в разделителя на поръчката: дата · час и — когато по сметката са
 * маркирали двама и повече — кой я е маркирал („14:32 · Мария Петрова", в
 * тесния вид „14:32 · М.П."). Часът е моноширинен с главни букви както досега;
 * името — с обикновения шрифт, без разредка, за да е плътно. Надписът НЕ се
 * свива (както часът досега) — иначе дълъг коментар до него би го застъпил;
 * дългото име се реже с „…" на собствения си таван.
 */
export const OrderBatchStamp = ({
  stamp,
  waiter,
}: {
  stamp: string;
  waiter: BatchWaiterLabel | null;
}) => (
  <span className="flex shrink-0 items-baseline gap-1.5 text-pos-muted">
    <span className="font-pos-mono text-[11px] tracking-[.09em] uppercase">{stamp}</span>
    {waiter && (
      <>
        <span aria-hidden className="text-[11px]">
          ·
        </span>
        <span
          title={waiter.fullName}
          className="max-w-[200px] truncate font-pos-sans text-[12px] font-medium leading-[1.2]"
        >
          {waiter.label}
        </span>
      </>
    )}
  </span>
);
